export default {
  dealers: [],
  dealerDelete: null,
  not_approved_dealers: null,
}
